<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container detail nft-detail" v-if="info">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div
          class="page-title sub name"
          v-if="info && (info.category_id === 2 || info.category_id === 3)">
          {{ info.event_title }}
        </div>
      </div>
      <div
        class="detail-info"
        :class="
          info.category_id === 2
            ? 'type3 type9'
            : info.category_id === 3
            ? 'type3'
            : 'type2'
        ">
        <div
          class="img-box"
          v-if="info.image"
          :style="{
            backgroundImage: 'url(' + $store.state.imgUrl + info.image + ')'
          }"></div>

        <div class="share-w">
          <div class="share" @click="handleShare">
            <span>{{ $t('share') }}</span>
          </div>
        </div>
        <RuleBtn
          v-if="info.from_source !== 2"
          :type="info.from === 1 ? '3' : '4'" />
        <div class="pro-info">
          <div class="flexable">
            <div class="fan">
              x
              <span class="num"
                ><span>{{ info.multiple }}</span></span
              >
            </div>
            <div
              class="info"
              @click="
                () => {
                  ;(this.popType = 'info'), (this.popupVisible = true)
                }
              ">
              {{ $t('nftpage.text3') }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="list3"
        v-if="info.category_id === 2 || info.category_id === 3">
        <div class="title">{{ $t('new.text65') }}</div>
        <div class="des">
          {{ info.event_desc }}
        </div>
      </div>
      <div class="list3" v-if="info.category_id === 3">
        <div class="title">{{ $t('new.text64') }}</div>
        <div class="content">
          <div class="flexable">
            <div class="label">{{ $t('new.text61') }}</div>
            <div
              class="val"
              @click="
                () => {
                  ;(this.popType = 'more'), (this.popupVisible = true)
                }
              ">
              {{ info.space_time_id }}
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('new.text62') }}</div>
            <div class="val">{{ info.space_block_id }}</div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('new.text63') }}</div>
            <div class="val">{{ info.space_id }}</div>
          </div>
        </div>
      </div>
      <div class="list3">
        <div class="title">{{ $t('nftpage.text4') }}</div>
        <div
          class="golden"
          v-if="info.category_id === 2 || info.category_id === 3">
          {{ info.event_privilege }}
        </div>
        <div class="content" v-else>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text5') }}</div>
            <div
              class="val question"
              @click="
                () => {
                  ;(this.popType = 'more'), (this.popupVisible = true)
                }
              ">
              {{ $t('add.text76') }}
            </div>
          </div>
          <div class="flexable" v-if="info.from === 1">
            <div class="label discod">{{ $t('discord') }}</div>
            <a
              class="val"
              @click="handleBuy"
              v-if="
                $store.state.role === 'user' &&
                info.from === 1 &&
                !info.is_buyed
              "
              >{{ $t('nftpage.text7') }}</a
            >
            <a
              class="val"
              v-if="
                ($store.state.role === 'user' &&
                  info.from === 1 &&
                  info.is_buyed) ||
                $store.state.role === 'babe'
              "
              :href="info.discord_channel_url"
              >{{ $t('new.text24') }}</a
            >
          </div>
        </div>
      </div>
      <div class="detail-des" v-if="info.babe_name">
        <div class="title">
          <div
            class="ava"
            :style="{
              backgroundImage:
                'url(' + $store.state.imgUrl + info.babe_avatar + ')'
            }"></div>
          {{ info.babe_name }}
        </div>
        <div class="des">
          {{ info.babe_profile }}
        </div>
      </div>
      <template
        v-if="
          info.from === 1 &&
          (((info.category_id === 0 || info.category_id === 1) &&
            !info.is_buyed) ||
            (info.category_id === 3 &&
              !info.is_buyed &&
              info.space_status === 1) ||
            info.category_id === 2)
        ">
        <div class="footer">
          <div class="price">
            <span>{{ $handleNum(info.price) }}</span>
          </div>
          <el-button
            type="primary"
            @click="handleBuy"
            class="block el-button--special"
            style="color: #ffffff"
            ><span v-if="info.is_buyed">{{ $t('new.text79') }}</span
            ><span v-else>{{ $t('nftpage.text8') }}</span></el-button
          >
          <div class="shop-detail" v-if="info.is_buyed">
            <span class="btn" @click="handleDetails">{{
              $t('new.text51')
            }}</span>
          </div>
        </div>
        <div class="open-area" style="height: 1.5rem"></div>
      </template>
      <template
        v-if="info.from === 1 && info.category_id === 3 && info.is_buyed">
        <div class="footer">
          <div
            class="result-box"
            ref="rbox"
            style="margin-top: 0.2rem; margin-bottom: 0.2rem">
            <div
              style="
                text-align: center;
                font-size: 0.24rem;
                margin-bottom: 0.2rem;
              ">
              <span
                v-if="info.space_status === 1 && info.my_reward_score === 0">
                <div class="row">
                  <span class="ti">{{ $t('new.text27') }}</span>
                  <span class="pr">{{ $handleNum(info.my_bet_amount) }}</span>
                </div>
                <div class="des">{{ $t('new.text28') }}</div>
                <div class="des2">
                  {{ $t('new.text29') }}
                </div>
              </span>
              <span v-if="info.my_reward_score !== 0">🎉🎉🎉</span>
              <span v-if="info.space_status === 2 && info.my_reward_score === 0"
                >💔💔💔</span
              >
            </div>
            <div class="h hh">
              <span v-if="info.my_reward_score !== 0">{{
                $t('congratulations')
              }}</span>
              <span
                v-if="info.space_status === 2 && info.my_reward_score === 0"
                >{{ $t('new.text52') }}</span
              >
            </div>
            <div
              class="dis"
              v-if="info.my_reward_score !== 0"
              v-html="$t('new.text31', { price: info.my_reward_score })"></div>
            <div
              class="dis"
              v-if="info.space_status === 2 && info.my_reward_score === 0">
              {{ $t('new.text53') }}
            </div>
            <div
              class="show-more-detail"
              @click="handleMore"
              v-if="rewards && rewards.length > 0">
              {{ $t('new.text54') }}
              <i class="el-icon-arrow-up" v-if="!showMore"></i
              ><i class="el-icon-arrow-down" v-else></i>
            </div>
          </div>
          <div
            class="detail-box"
            v-if="showMore"
            :style="{ height: scrollHeight2 + 'px', 'overflow-y': 'scroll' }">
            <div class="list1 type2" v-if="rewards && rewards.length > 0">
              <div class="item" v-for="(item, index) in rewards" :key="index">
                <div class="flexable">
                  <div class="text text0">
                    <div class="label" @click="handleQa('1')">
                      {{ $t('web5token') }}
                    </div>
                    <div class="value">+ {{ $handleNum(item.score) }}</div>
                  </div>
                  <div class="btns ar">
                    <div class="status">{{ $t('new.text66') }}</div>
                    <div class="des">{{ item.created_at }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="open-area" style="height: 2.2rem"></div>
      </template>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :modal="false"
      :closeOnClickModal="false">
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div class="pop-box buy" v-if="popType === 'buy'">
        <div class="pop-title">{{ $t('purchasenft') }}</div>
        <div
          class="flexable top"
          :class="info.category_id === 2 ? 'boxtype9' : ''">
          <div
            class="img-box"
            :style="{
              backgroundImage: 'url(' + $store.state.imgUrl + info.image + ')'
            }"></div>
          <div class="cont">
            <span class="info">{{ $t('nftpage.text3') }}</span>
            <div class="flexlist">
              <div class="flexable">
                <div class="label">{{ $t('nftpage.text9') }}</div>
                <div class="val">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="info.token_id.toString()"
                    placement="top-start">
                    <span>{{ parseText(info.token_id) }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="flexable">
                <div class="label">{{ $t('nftpage.text10') }}</div>
                <div class="val">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="info.nft_contract"
                    placement="top-start">
                    <span>{{ parseText(info.nft_contract) }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="flexable">
                <div class="label">{{ $t('nftpage.text11') }}</div>
                <div class="val">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="info.nft_blockchain"
                    placement="top-start">
                    <span>{{ parseText(info.nft_blockchain) }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="flexable">
                <div class="label">{{ $t('nftpage.text12') }}</div>
                <div class="val">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="info.nft_standard"
                    placement="top-start">
                    <span>{{ parseText(info.nft_standard) }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="flexable">
            <div class="label">{{ $t('price') }}</div>
            <div class="price">
              <span>{{ $handleNum(info.price) }}</span>
            </div>
          </div>
        </div>
        <div class="line" v-if="info.category_id === 2">
          <div class="flexable">
            <div class="label">{{ $t('count') }}</div>
            <div
              class="num-box"
              style="padding-bottom: 0; margin-right: -0.09rem">
              <div
                class="btn down"
                @click="handleDown"
                :class="disabled ? 'disabled' : ''"></div>
              <span class="num-val">{{ count }}</span>
              <div
                class="btn up"
                @click="handleUp"
                :class="disabled2 ? 'disabled' : ''"></div>
            </div>
          </div>
        </div>
        <div class="line" v-if="info.category_id === 2">
          <div class="flexable arrow" @click="handleAddressChange">
            <div class="label">{{ $t('new.text34') }}</div>
            <div class="price">
              <div class="address" v-if="address">
                <div class="name">{{ address.name }},{{ address.phone }}</div>
                {{ address.address2 }},{{ address.address1 }},{{
                  address.city
                }},{{ address.state }},{{ address.area }}
              </div>
              <a @click="handleRoute('/user/address?from=UserNftDetail')" v-else
                >+ {{ $t('new.text35') }}</a
              >
            </div>
          </div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.55rem; color: #ffffff"
          @click="handleBuyConfirm"
          >{{ $t('continue') }}</el-button
        >
      </div>
      <div class="pop-box" v-if="popType === 'details'">
        <div class="pop-title" ref="popTitle">{{ $t('new.text60') }}</div>
        <div class="pop-content" :style="{ height: scrollHeight + 'px' }">
          <div class="line" v-for="(item, index) in detailList" :key="index">
            <div class="flexable">
              <div class="item">
                <div class="flexable">
                  <div class="idd">
                    <i class="el-icon-s-order"></i> {{ item.order_id }}
                  </div>
                </div>
                <div class="flexable">
                  <div class="label">x 1</div>
                  <div class="price">
                    <span>{{ $handleNum(item.score) }}</span>
                  </div>
                </div>
                <div class="flexable">
                  <div class="date">{{ item.created_at }}</div>
                  <div
                    class="ship-status"
                    @click="handleShowOrder(item)"
                    v-if="info.category_id === 2">
                    <span v-if="item.express_status === 1"
                      ><i class="el-icon-present"></i>
                      {{ $t('new.text58') }}</span
                    >
                    <span v-else
                      ><i class="el-icon-truck"></i>
                      {{ $t('new.text59') }}</span
                    >
                  </div>
                </div>
                <div class="ship-detail" v-if="item.showOrder">
                  <div class="flexable">
                    <div class="label">{{ $t('new.text34') }}</div>
                    <div class="address" v-if="item.address_info">
                      {{ item.address_info.name }},{{
                        item.address_info.phone
                      }}, {{ item.address_info.address2 }},{{
                        item.address_info.address1
                      }},{{ item.address_info.city }},{{
                        item.address_info.state
                      }},{{ item.address_info.area }}
                    </div>
                  </div>
                  <div class="flexable" v-if="item.express_no">
                    <div class="label">{{ $t('new.text47') }}</div>
                    <div class="idd">
                      {{ item.express_no }}
                      <a
                        ref="link"
                        :href="item.express_info"
                        target="_blank"></a>
                      <i
                        class="el-icon-search"
                        @click="handleCopy(item.express_no)"></i>
                    </div>
                  </div>
                  <div class="flexable" v-if="item.express_at">
                    <div class="label">{{ $t('new.text48') }}</div>
                    <div class="date">{{ item.express_at }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-box buy" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('purchasenft') }}</div>
        <template v-if="info && info.category_id !== 2">
          <div class="result-box" style="margin-top: 0.3rem">
            <div class="h icons success">{{ $t('successed') }}</div>
            <div class="des">
              {{ $t('nftpage.text17') }}
            </div>
          </div>
          <el-button
            class="el-button--white block"
            style="margin-top: 0.55rem"
            @click="handleSuccess"
            >{{ $t('ok') }}</el-button
          >
        </template>
        <template v-if="info && info.category_id === 2">
          <div class="result-box" style="margin-top: 0.3rem">
            <div class="h icons success">{{ $t('new.text49') }}</div>
            <div class="des">
              {{ $t('new.text50') }}
            </div>
          </div>
          <el-button
            class="el-button--white block"
            style="margin-top: 0.55rem"
            @click="handleKnow"
            >{{ $t('add.text50') }}</el-button
          >
        </template>
      </div>
      <div class="pop-box buy" v-if="popType === 'fail'">
        <div class="pop-title">{{ $t('purchasenft') }}</div>
        <div class="result-box">
          <div class="h icons warning">{{ $t('add.text42') }}</div>
          <div class="des">{{ $t('add.text43') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="handleRoute('/user/account')"
          >{{ $t('add.text44') }}</el-button
        >
      </div>
      <div class="pop-box type2" v-if="popType === 'info'">
        <div class="pop-title">{{ $t('nftpage.text3') }}</div>
        <div class="pop-list">
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text9') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.token_id"
                placement="top-start">
                <span>{{ parseText(info.token_id) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text10') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_contract"
                placement="top-start">
                <span>{{ parseText(info.nft_contract) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text11') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_blockchain"
                placement="top-start">
                <span>{{ parseText(info.nft_blockchain) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text12') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_standard"
                placement="top-start">
                <span>{{ parseText(info.nft_standard) }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-box type2" v-if="popType === 'more'">
        <div class="pop-title">{{ $t('nftpage.text13') }}</div>
        <div v-html="$t('nftpage.text14')" v-if="info.from_source === 1"></div>
        <div
          v-html="$t('nftpage.text16')"
          v-else-if="info.from_source === 2"></div>
        <div v-html="$t('nftpage.text15')" v-else></div>
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import {
  postAddressList,
  postMySpaceRewards,
  postNftBuy,
  postNftInfo,
  postShoppingLists
} from '@/api/user'
import RuleBtn from '@/components/RuleBtn.vue'
import SharePop from '@/components/SharePop.vue'

export default {
  name: 'UserNftDetail',
  components: {
    SharePop,
    RuleBtn
  },
  data() {
    return {
      popupVisible: false,
      selected: '1',
      info: null,
      popType: null,
      address: null,
      count: 1,
      disabled: true,
      disabled2: false,
      maxCount: null,
      detailList: null,
      scrollHeight: 0,
      scrollHeight2: 0,
      showMore: false,
      rewards: null
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  activated() {
    console.log(888)
    if (this.$store.state.fromName === 'UserAddress') {
      let params = {
        page: 1,
        size: 10
      }
      postAddressList(params).then((res) => {
        if (res.data.lists.length > 0) {
          if (localStorage.getItem('selectedAddress')) {
            let address = JSON.parse(localStorage.getItem('selectedAddress'))
            let hasAddress = res.data.lists.find((item) => {
              return item.id === address.id
            })
            if (hasAddress) {
              this.address = address
            } else {
              this.address = res.data.lists[0]
            }
          } else {
            this.address = res.data.lists[0]
          }
        } else {
          this.address = null
        }
      })
    } else {
      this.popupVisible = false
      this.init()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'UserAddress' || to.name === 'UserQa') {
    } else if (to.name === this.$store.state.fromName) {
      this.$store.commit('SET_KEEP_ALIVE', [to.name])
    } else {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    console.log(this.$store.state.keepAlive)
    next()
  },
  methods: {
    handleCopy(data) {
      let elInput = document.createElement('input')
      elInput.value = data
      document.body.appendChild(elInput)
      // 选择对象
      elInput.select()
      console.log(elInput, elInput.value)
      // 执行浏览器复制命令
      this.$toast({ message: this.$t('add.text34') })
      document.execCommand('Copy')
      elInput.remove()
      this.$refs.link[0].click()
    },
    handleRoute(path) {
      this.$router.push({ path: path })
    },
    handleAddressChange() {
      this.handleRoute('/user/address?from=UserNftDetail')
    },
    init() {
      let params = {
        rec_code: this.$route.query.rec_code
      }
      postNftInfo(params).then((res) => {
        if (res.data.my_reward_score) {
          res.data.my_reward_score = this.$handleNum(res.data.my_reward_score)
        }
        if (res.data.total_count && res.data.total_count > 0) {
          this.maxCount = res.data.total_count - res.data.sell_count
        }
        this.info = res.data
        if (this.info.category_id === 2) {
          let params = {
            page: 1,
            size: 10
          }
          postAddressList(params).then((res) => {
            if (res.data.lists.length > 0) {
              if (localStorage.getItem('selectedAddress')) {
                let address = JSON.parse(
                  localStorage.getItem('selectedAddress')
                )
                let hasAddress = res.data.lists.find((item) => {
                  return item.id === address.id
                })
                if (hasAddress) {
                  this.address = address
                } else {
                  this.address = res.data.lists[0]
                }
              } else {
                this.address = res.data.lists[0]
              }
            }
          })
        }
      })
      postMySpaceRewards(params).then((res) => {
        this.rewards = res.data
      })
    },
    handleShare() {
      if (!this.$store.state.token) {
        this.$bus.emit('handleLogin')
      } else {
        this.sharePath =
          this.$store.state.userPath +
          '/user/nftdetail?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteNft=' +
          this.info.rec_code +
          '&rec_code=' +
          this.info.rec_code
        console.log(this.sharePath)
        this.popType = 'share'
        this.popupVisible = true
      }
    },
    handleBack() {
      this.$router.back()
    },
    handleShowOrder(item) {
      this.detailList = this.detailList.map((e) => {
        if (item.id === e.id) {
          e.showOrder = !e.showOrder
        }
        return e
      })
    },
    handleBuy() {
      this.popType = 'buy'
      this.popupVisible = true
    },
    parseText(text) {
      if (typeof text !== 'string') {
        text = text.toString()
      }
      if (text.length > 21) {
        text = text.slice(0, 6) + '...' + text.substring(text.length - 4)
      }
      return text
    },
    handleBuyConfirm() {
      if (
        this.$store.state.user_info &&
        this.$store.state.user_info.web5_score >= this.info.price
      ) {
        let params = {
          rec_code: this.$route.query.rec_code
        }
        if (localStorage.getItem('inviteCode')) {
          params.user_rec_code = localStorage.getItem('inviteCode')
        }
        if (
          localStorage.getItem('inviteCode') &&
          localStorage.getItem('inviteNft') &&
          localStorage.getItem('inviteNft') === this.$route.query.rec_code
        ) {
          params.user_rec_code = localStorage.getItem('inviteCode')
        }
        if (this.info.category_id === 2) {
          if (!this.address) {
            this.$toast({ message: 'Please add the address.' })
            return
          } else {
            params.address_id = this.address.id
          }
        }
        if (this.info.category_id === 2 || this.info.category_id === 3) {
          params.count = this.count
        }
        postNftBuy(params).then((res) => {
          if (res.errorCode === 0) {
            this.popType = 'success'
            this.$store.dispatch('setRefresh', {
              name: 'UserAccount',
              type: true
            })
          }
        })
      } else {
        this.popType = 'fail'
        this.popupVisible = true
      }
    },
    handleQa(type) {
      this.$router.push({ path: '/user/qa', query: { type: type } })
    },
    handleDetails() {
      let params = {
        rec_code: this.$route.query.rec_code
      }
      postShoppingLists(params).then((res) => {
        this.detailList = res.data.lists
        this.popType = 'details'
        this.popupVisible = true
        this.$nextTick(() => {
          this.scrollHeight =
            document.documentElement.clientHeight -
            this.$refs.popTitle.clientHeight -
            this.$store.state.remTopx * (0.4 + 0.06)
        })
      })
    },
    handleSuccess() {
      this.popupVisible = false
      this.$router.push({ path: '/user/account' })
    },
    handleKnow() {
      this.popupVisible = false
      this.init()
    },
    handleDown() {
      if (this.count >= 2) {
        this.count -= 1
      }
      if (this.count < this.maxCount) {
        this.disabled2 = false
        if (this.count >= 2) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    },
    handleUp() {
      if (this.count < this.maxCount) {
        this.count = parseInt(this.count) + 1
      }
      if (this.count > 1) {
        this.disabled = false
      }
      if (this.count >= this.maxCount) {
        this.disabled2 = true
      }
    },
    handleMore() {
      this.showMore = !this.showMore
      if (this.showMore) {
        this.$nextTick(() => {
          this.scrollHeight2 =
            document.documentElement.clientHeight -
            this.$refs.rbox.clientHeight -
            this.$store.state.remTopx * (0.4 + 0.16 * 2 + 0.62 + 0.04)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/nftdetail.vue